import styled from 'styled-components'

const ModalButtonRow = styled.div`
  display: flex;
  justify-content: flex-end;
  flex: 1 1 100%;
`

export default ModalButtonRow
